// extracted by mini-css-extract-plugin
module.exports = {"region":"styles_region__1d91o","snackbar":"styles_snackbar__3d0_W","enter":"styles_enter__2JyOf","message":"styles_message__mi02q"};